import { Card } from "@nelurio/ui";
import { useI18n } from "@nelurio/i18n";

/**
 * Public legal pages (Impressum §5 TMG + GDPR privacy notice).
 * Placeholders in [BRACKETS] must be filled with the operator's real data
 * before going commercial — German law requires them.
 */
export function LegalPage({ page }: { page: "imprint" | "privacy" }) {
  const { locale } = useI18n();
  const german = locale.startsWith("de");
  const isImprint = page === "imprint";

  return (
    <main className="legal-page">
      <Card className="legal-card">
        {isImprint ? (
          german ? (
            <>
              <h1>Impressum</h1>
              <h2>Angaben gemäß § 5 TMG</h2>
              <p>
                Nelurio — [VOR- UND NACHNAME]<br />
                [STRASSE UND HAUSNUMMER]<br />
                [PLZ ORT], Deutschland
              </p>
              <h2>Kontakt</h2>
              <p>E-Mail: aabrahimiyan@gmail.com</p>
              <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p>[VOR- UND NACHNAME], Anschrift wie oben</p>
              <h2>Haftung für Inhalte</h2>
              <p>
                Die Inhalte dieser Anwendung wurden mit großer Sorgfalt erstellt. Für Richtigkeit,
                Vollständigkeit und Aktualität wird keine Gewähr übernommen. Nelurio wird während der
                Beta-Phase „wie besehen" ohne Gewährleistung bereitgestellt.
              </p>
              <h2>Urheberrecht</h2>
              <p>Die Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.</p>
            </>
          ) : (
            <>
              <h1>Legal Notice (Impressum)</h1>
              <h2>Information according to § 5 TMG</h2>
              <p>
                Nelurio — [FULL NAME]<br />
                [STREET AND NUMBER]<br />
                [POSTAL CODE CITY], Germany
              </p>
              <h2>Contact</h2>
              <p>Email: aabrahimiyan@gmail.com</p>
              <h2>Content liability</h2>
              <p>
                Contents were created with care, but no guarantee is given for accuracy or completeness.
                During the beta phase Nelurio is provided “as is”, without warranty.
              </p>
            </>
          )
        ) : german ? (
          <>
            <h1>Datenschutzerklärung</h1>
            <h2>1. Verantwortlicher</h2>
            <p>[VOR- UND NACHNAME], [ANSCHRIFT], E-Mail: aabrahimiyan@gmail.com</p>
            <h2>2. Datenverarbeitung</h2>
            <p>
              Beim Nutzung der Anwendung werden ausschließlich die zur Bereitstellung nötigen Daten
              verarbeitet: E-Mail-Adresse, Anzeigename, Lerninhalte (Kurse, Notizen, Dateien),
              Lernfortschritt und technische Session-Daten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
              (Vertrag) bzw. lit. f (berechtigtes Interesse an sicherem Betrieb).
            </p>
            <h2>3. Hosting</h2>
            <p>
              Die Anwendung läuft auf einem Server in der EU. Zugriffsdaten (IP-Adresse, Zeitpunkt)
              werden zur technischen Bereitstellung verarbeitet.
            </p>
            <h2>4. KI-Funktionen</h2>
            <p>
              Für Zusammenfassungen und den Tutor werden eingegebene Lerninhalte an den
              KI-Anbieter (OpenAI, EU/US, ADV vereinbart) übermittelt. Antworten werden ausschließlich
              aus den eigenen Materialien des Nutzers erzeugt.
            </p>
            <h2>5. Deine Rechte</h2>
            <p>
              Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Datenübertragbarkeit
              und Widerspruch (Art. 15–21 DSGVO). Löschung und Datenexport kannst du selbstständig
              in den Einstellungen auslösen. Außerdem besteht ein Beschwerderecht bei einer Aufsichtsbehörde.
            </p>
            <h2>6. Speicherdauer</h2>
            <p>Daten werden gespeichert, bis du die Löschung deines Kontos verlangst.</p>
          </>
        ) : (
          <>
            <h1>Privacy Policy</h1>
            <h2>1. Controller</h2>
            <p>[FULL NAME], [ADDRESS], Email: aabrahimiyan@gmail.com</p>
            <h2>2. Data we process</h2>
            <p>
              Only what is required to provide the service: email, display name, study content
              (courses, notes, files), learning progress and technical session data.
              Legal basis: Art. 6 (1) b and f GDPR.
            </p>
            <h2>3. Hosting</h2>
            <p>Hosted on a server within the EU; access logs (IP, timestamp) processed for delivery.</p>
            <h2>4. AI features</h2>
            <p>
              Summaries and tutor answers send your study content to the AI provider
              (OpenAI, DPA in place). Answers are generated strictly from your own materials.
            </p>
            <h2>5. Your rights</h2>
            <p>
              Access, rectification, erasure, portability and objection (Art. 15–21 GDPR).
              You can trigger deletion and export yourself from Settings at any time.
            </p>
            <h2>6. Retention</h2>
            <p>Data is stored until you request account deletion.</p>
          </>
        )}
        <p className="legal-back"><a href="/auth">← {german ? "Zurück" : "Back"}</a></p>
      </Card>
    </main>
  );
}
